import React, { Component } from 'react';
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import "react-progress-2/main.css"
import Progress from "react-progress-2";
import AppRoutes from './AppRoutes'
class App extends Component {
  render() {
    return (
      <div>
        <Progress.Component/>
        <AppRoutes/>
      </div>
    );
  }
}


export default withRouter(connect(state =>({}))(App))



// WEBPACK FOOTER //
// ./src/App.js